import type { RadarBubble } from "@/services/api/teacher";

export type TeacherCodeMark = {
  teacherId: string;
  code: string;
  name: string;
  angleDeg: number;
  bubbleCount: number;
};

export function teacherCodeMarks(bubbles: RadarBubble[]): TeacherCodeMark[] {
  const byTeacher = new Map<string, TeacherCodeMark>();
  for (const bubble of bubbles) {
    const teacherId = bubble.requester_teacher_id;
    if (!teacherId) continue;
    const code = bubble.requester_short_code?.trim() || "???";
    const count = bubble.lesson_count || 1;
    const existing = byTeacher.get(teacherId);
    if (!existing) {
      byTeacher.set(teacherId, {
        teacherId,
        code,
        name: bubble.requester_name?.trim() || code,
        angleDeg: bubble.angle_degrees ?? 0,
        bubbleCount: count,
      });
      continue;
    }
    existing.bubbleCount += count;
  }
  return [...byTeacher.values()];
}

export function talkCodeHidden(
  bubble: Pick<
    RadarBubble,
    "requester_teacher_id" | "hours_until_lesson" | "is_in_panic_zone"
  >,
  collapsedIds: ReadonlySet<string>,
  panicThreshold: number
): boolean {
  if (!bubble.requester_teacher_id || !collapsedIds.has(bubble.requester_teacher_id)) {
    return false;
  }
  if (bubble.is_in_panic_zone) return false;
  const hours = Number.isFinite(bubble.hours_until_lesson)
    ? bubble.hours_until_lesson
    : panicThreshold + 1;
  return hours > panicThreshold;
}
